import { ChangeDetectionStrategy, Component, computed, OnInit, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticatedPageComponent } from 'src/app/components/base.component';
import { MainpageComponent } from 'src/app/components/mainpage/mainpage.component';
import { Friendship, InventoryItem, ItemUse, PetDTO, Shop } from 'src/app/dto';
import { ApplicationService } from 'src/app/services/application.service';
import { InboxService } from 'src/app/services/inbox.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { PetService } from 'src/app/services/pet.service';
import { ShopService } from 'src/app/services/shop.service';

export interface ItemStack {
    instances: InventoryItem[]; // instances[0] is the display representative
}

@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InventoryComponent extends AuthenticatedPageComponent implements OnInit {

    public static route = 'inventory';

    groupedItems: Signal<ItemStack[]>;
    friends: Observable<Friendship[]>;
    shops: Observable<Shop[]>;
    activePets: Observable<PetDTO[]>;

    selectedFriend: string;
    selectedShop: number;
    selectedPet: PetDTO;

    selectedPetOption: { pet: PetDTO; use: ItemUse };

    constructor(protected coreAppService: ApplicationService, private inboxService: InboxService, private inventory: InventoryService, private shopService: ShopService, private pet: PetService, router: Router) {
        super(router, coreAppService.authService, MainpageComponent.route, coreAppService.uiStateService);
        this.groupedItems = computed(() => {
            const items = this.inventory.activeUserInventorySignal();
            const byType = new Map<number, InventoryItem[]>();
            for (const item of items) {
                const key = item.ItemType.Id;
                if (!byType.has(key)) byType.set(key, []);
                byType.get(key).push(item);
            }
            return Array.from(byType.values()).map(instances => ({ instances }));
        });
        this.friends = this.inboxService.friendsList$;
        this.activePets = this.pet.activeUserPets;
        this.shops = this.shopService.activeUserShops;
    }

    ngOnInit(): void {
        this.subscribe(this.activeUser$, user => {
            if (user && this.authService.isAuthenticated()) {
                this.inventory.initializeInventory();
            }
        });
    }

    dismissModal(modal: any) {
        modal.dismiss();
        return true;
    }
}
